export enum Sort {
    Descending, None, Ascending
}